var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-confirm-dialog" },
    [
      _c(
        "x-dialog",
        {
          staticClass: "app-confirm-dialog-position app-pr",
          attrs: { show: _vm.show }
        },
        [
          _c("div", { staticClass: "top" }),
          _vm._v(" "),
          _c("div", { staticClass: "center app-oh" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v("\n        温馨提示\n      ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [
              _vm._v("\n        请确认促销折扣实物已全部送达及验收\n      ")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bottom" }, [
            _c("div", { staticClass: "bottom-left", on: { click: _vm.exit } }, [
              _vm._v("\n        取消\n      ")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "bottom-right", on: { click: _vm.confirm } },
              [_vm._v("\n        确定\n      ")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "icon-box" }, [
            _c("div", { staticClass: "icon" })
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-80c06008", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80c06008","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/simple/appConfirmDialog/App-confirm-dialog.vue
// module id = null
// module chunks = 